import { IAccountFeatureMessage } from 'src/app/interfaces/iaccount-feature';

const ENGLISH_LANGUAGE_CODE = 'en';

// Exact locale, then same-language variant, then English, then nothing.
export function selectMessageForLanguage(
  messages: IAccountFeatureMessage[],
  browserLanguage: string = navigator.language,
): string | null {
  return selectMessageForLanguages(messages, [browserLanguage]);
}

// Tries each language in order (exact locale, then same-language variant), then English, then nothing.
// Empty entries are skipped, e.g. a call with no language set.
export function selectMessageForLanguages(
  messages: IAccountFeatureMessage[],
  languages: (string | null | undefined)[],
): string | null {
  for (const language of languages) {
    if (!language) continue;

    const exactMatch = messages.find((message) => message.languageCode === language);
    if (exactMatch) return exactMatch.messageText;

    const baseLanguage = language.split('-')[0];
    const sameLanguageMatch = messages.find((message) => message.languageCode.split('-')[0] === baseLanguage);
    if (sameLanguageMatch) return sameLanguageMatch.messageText;
  }

  const englishMatch = messages.find((message) => message.languageCode.split('-')[0] === ENGLISH_LANGUAGE_CODE);
  return englishMatch?.messageText ?? null;
}
